import { __awaiter, __generator } from "tslib";
import { createElement } from '@gn-audio/core/common/templating';
import './basket-engraving-item.component.scss';
import template from './basket-engraving-item.component.html';
var BasketEngravingItemComponent = /** @class */ (function () {
    function BasketEngravingItemComponent() {
        var _this = this;
        this.setEngraving = function () {
            _this.eventBus.post("show-engraving-popup" /* BasketEvent.ShowEngravingPopup */, _this.productItem, _this.applyEngraving);
        };
        this.removeEngraving = function () {
            var _a = _this.productItem, item_id = _a.item_id, quantity = _a.quantity;
            _this.eventBus.post("set-service-value" /* BasketEvent.SetServiceValue */, item_id, quantity, null, null, '');
        };
        this.applyEngraving = function (message) {
            var _a = _this.productItem, item_id = _a.item_id, quantity = _a.quantity;
            _this.eventBus.post("set-service-value" /* BasketEvent.SetServiceValue */, item_id, quantity, null, null, message);
        };
    }
    BasketEngravingItemComponent.prototype.render = function (_a) {
        var eventBus = _a.eventBus, container = _a.container, data = _a.data, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            var engravingText;
            return __generator(this, function (_b) {
                this.eventBus = eventBus;
                this.productItem = data.product;
                this.element = createElement(template, null, translations);
                container.insertAdjacentElement('beforeend', this.element);
                this.addAction = this.element.querySelector('.basket-engraving-item__action.add');
                this.removeAction = this.element.querySelector('.basket-engraving-item__action.remove');
                this.editAction = this.element.querySelector('.basket-engraving-item__action.edit');
                this.message = this.element.querySelector('.basket-engraving-item__message');
                if (this.productItem.c_engravingMsg) {
                    this.removeAction.classList.add('visible');
                    this.editAction.classList.add('visible');
                    engravingText = this.productItem.c_engravingMsg;
                    this.message.innerHTML = "".concat(translations.Engraving, ": \"").concat(engravingText, "\"");
                    this.message.setAttribute('title', engravingText);
                    this.message.classList.add('bold');
                }
                else {
                    this.addAction.classList.add('visible');
                    this.message.innerHTML = translations.EngravingEmptyMessage;
                    this.message.classList.remove('bold');
                }
                this.addAction.addEventListener('click', this.setEngraving);
                this.editAction.addEventListener('click', this.setEngraving);
                this.removeAction.addEventListener('click', this.removeEngraving);
                return [2 /*return*/];
            });
        });
    };
    BasketEngravingItemComponent.prototype.destroy = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.addAction.removeEventListener('click', this.setEngraving);
                this.editAction.removeEventListener('click', this.setEngraving);
                this.removeAction.removeEventListener('click', this.removeEngraving);
                (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
                return [2 /*return*/];
            });
        });
    };
    return BasketEngravingItemComponent;
}());
export { BasketEngravingItemComponent };
